/**
 * B447 — §7 step 5 as POLICY, not prose. The webhook confirms the order
 * server-side; the storefront observes it by polling `order.get`. The
 * cadence and the keep-polling decision were inline in App.tsx, which
 * left the native twins (B447) nothing to replay — extracted here so the
 * web and the mobile apps share one truth (the B448 TICKET_QR_OPTIONS
 * precedent: a change reddens the wall, never forks the policy).
 *
 * The decision: an AUTHORIZED order outlives its hold deadline (B29
 * defers capture), so polling continues past `holdExpiresAt`; an
 * unauthorized order stops being asked about the moment the hold is
 * gone — `now >= holdExpiresAt` is the boundary (at the deadline, no
 * poll). Every tick still dispatches TICK regardless: the flow reducer
 * owns EXPIRED, not this policy.
 */

/** The web's cadence — the native twins poll at the same interval. */
export const ORDER_POLL_INTERVAL_MS = 3_000;

/** Whether this tick asks the server, given the §7 hold rules above. */
export function shouldPollOrder(input: {
  readonly authorized: boolean;
  readonly now: number;
  readonly holdExpiresAt: number;
}): boolean {
  return input.authorized || input.now < input.holdExpiresAt;
}
